import { api } from '@/services';

import { PROFILES_API_ENDPOINTS } from '@/constants';
import { ApiResponse, PagedResponse } from '@/types';

import {
  IFaceIdProfile,
  IFaceIdProfileDetails,
  IFaceIdProfileSearchingPayload,
} from '@/features/face-id-profiles/interfaces';

const FaceIdProfileService = {
  ProfilesSearching: async (
    payload: IFaceIdProfileSearchingPayload,
  ): Promise<PagedResponse<IFaceIdProfile>> => {
    const response = await api.post<ApiResponse<PagedResponse<IFaceIdProfile>>>(
      PROFILES_API_ENDPOINTS.PROFILES_SEARCHING,
      payload,
    );
    return response.data.data;
  },
  GetFaceIdProfile: async (id: string): Promise<ApiResponse<IFaceIdProfileDetails>> => {
    const response = await api.get(PROFILES_API_ENDPOINTS.PROFILES_ID.replace(':profileId', id));
    return response.data;
  },
};

export default FaceIdProfileService;
